  const initState = {
    followupProgram: {},
    followupPrograms: [],
    followupProgramCount: 0,
  };
  
  const followupProgramReducer = (state = initState, action) => {
    switch (action.type) {
      case "SET_FOLLOWUP_PROGRAM_DATA":
        return {
          ...state,
          followupProgram: action.payload.data,
        };
      case "SET_FOLLOWUP_PROGRAM_COUNT":
        return {
          ...state,
          followupProgramCount: action.payload.data,
        };
      case "SET_FOLLOWUP_PROGRAMS_DATA":
        return {
          ...state,
          followupPrograms: action.payload.data,
        };
      default:
        return { ...state };
    }
  };
  
  export default followupProgramReducer;
  